export const themeFonts = {
  families: {
    polySans: "'PolySans', sans-serif",
    roboto: "'Roboto', sans-serif"
  },
  weights: {
    regular: 400,
    medium: 500,
    semiBold: 600
  },
  lineHeights: {
    xs: '16px',
    sm: '18px',
    md: '22px',
    lg: '28px',
    xl: '36px'
  },
  sizes: {
    xs: '12px',
    sm: '14px',
    base: '16px',
    lg: '20px',
    xl: '24px',
    xxl: '32px'
  }
} as const;
